import { useMutation } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';
import { useGanttSimulationTaskStateStore } from '../../components/organisms/ProductionPlans/Gantt/store';

type ToPublishTaskMutationInput = {
  taskId: number;
  type: 'task' | 'batch';
  toPublish: boolean;
};

export const publishTaskMutationKey = (simulationId: number, taskId: number) => [
  'gantt-simulation',
  'publish-task',
  simulationId,
  taskId,
];

export const useGanttSimulationPublishTask = (simulationId: number, taskId: number) => {
  const api = useGraphneAPI();
  const addTaskToPublishIds = useGanttSimulationTaskStateStore((state) => state.addTaskToPublishIds);
  const removeTaskToPublishIds = useGanttSimulationTaskStateStore((state) => state.removeTaskToPublishIds);

  return useMutation({
    mutationKey: publishTaskMutationKey(simulationId, taskId),
    mutationFn: (data: ToPublishTaskMutationInput) => {
      const payload = {
        simulationId: simulationId.toString(),
        p1: data.taskId.toString(),
      };

      if (data.type === 'task') {
        if (data.toPublish) {
          return api.postGraphneSimulationSimulationidTasksP1MarkToPublish(payload);
        } else {
          return api.postGraphneSimulationSimulationidTasksP1UnmarkToPublish(payload);
        }
      } else {
        if (data.toPublish) {
          return api.postGraphneSimulationSimulationidBatchesP1MarkToPublish(payload);
        } else {
          return api.postGraphneSimulationSimulationidBatchesP1UnmarkToPublish(payload);
        }
      }
    },
    onSuccess: (data, { toPublish }) => {
      if (toPublish) {
        addTaskToPublishIds(data);
      } else {
        removeTaskToPublishIds(data);
      }
    },
  });
};
